import {conversationApi} from '@/api/dify';
import {delete_chat, rename_chat} from '@/api/chat';
import {share_chat} from '@/api/login';

export default {
    data() {
        return {
            // 会话相关
            conversationList: [],
            collapsed_ids: [],
            activeConversation: null,
            isLoadingConversations: false,
            isCreatingChat: false,
            customMenu: [
                {
                    label: '修改名称',
                    key: 'rename',
                    icon: 'el-icon-edit',
                    command: 'rename',
                },
                {
                    label: '分享',
                    key: 'share',
                    icon: 'el-icon-share',
                    command: 'share',
                },
                {
                    label: '删除',
                    key: 'delete',
                    icon: 'el-icon-delete',
                    command: 'delete',
                    menuItemHoverStyle: {
                        color: '#F56C6C',
                        backgroundColor: 'rgba(245, 108, 108, 0.1)',
                    },
                },
            ],
            // 分享相关
            shareDialogVisible: false,
            shareUrl: '',
            shareExpireDay: 1, // 默认 1 天（每次打开弹窗都会重置）
            shareChatId: 0,
            shareModelId: 0, // 侧边栏分享整会话时传 0，列标题分享传对应模型 id
        };
    },
    computed: {
        currentConversationTitle() {
            const conversation = this.conversationList.find(item => item.id === this.activeConversation);
            return conversation ? conversation.label : '对话';
        },
    },
    methods: {
        // 加载会话列表
        async loadConversations() {
            try {
                this.isLoadingConversations = true;
                const response = await conversationApi.getConversations();
                // 转换数据格式以适配UI组件
                const formattedData = response.result.rows.map(item => {
                    return {
                        id: item.id,
                        label: item.title || '新对话',
                        prefixIcon: 'el-icon-chat-dot-round',
                        created_at: item.create_time,
                        group: item.robot_name,
                        robot_id: item.robot_id,
                        is_collapsed: item.is_collapsed
                    }
                })

                // 使用工具函数添加时间分组
                this.conversationList = formattedData
                this.collapsed_ids = response.result.collapsed_ids
            } catch (error) {
                this.$message.error('加载会话列表失败: ' + error.message);
            } finally {
                this.isLoadingConversations = false;
            }
        },

        // 处理会话切换
        async handleConversationChange(conversation) {
            this.chat_id = conversation.id
            this.uploadedFiles = []
            this.modelConversations = []
            this.model_ids = ''
            this.senderValue = ''
            this.summary_status = false //切换的时候关一下总结按钮
            this.activeConversation = conversation.id;
            //关闭智能体选择列表页面层
            this.showAgentUI = false;
            // 调用loadMessages加载历史消息
            await this.loadMessages(conversation.id);
            await this.chat_detail();
        },

        // 新建对话
        async handleNewChat() {
            try {
                this.summary_status = false
                //关闭智能体选择列表页面层
                this.showAgentUI = false;
                this.chat_id = 0
                this.modelConversations = [];
                this.senderValue = '';
                this.uploadedFiles = [];
                this.isCreatingChat = true;
                // 重置当前状态
                this.activeConversation = null;
                this.model_ids = ''
                await this.loadMessages(this.chat_id);
                await this.chat_detail()
            } catch (error) {
                this.$message.error('创建新对话失败: ' + error.message);
            } finally {
                this.isCreatingChat = false;
            }
        },

        // 处理菜单命令
        handleMenuCommand(command, item) {
            if (command === 'delete') {
                this.handleDeleteConversation(item);
            } else if (command === 'rename') {
                this.$prompt('请输入新的对话标题', '重命名对话', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValue: item.label,
                })
                    .then(({value}) => {
                        if (value && value.trim()) {
                            this.handleRenameConversation(item, value.trim());
                        }
                    })
                    .catch(() => {
                    });
            } else if (command === 'share') {
                this.handleShareConversation(item);
            }
        },

        // 删除会话
        async handleDeleteConversation(conversation) {
            try {
                await this.$confirm('确定要删除这个对话吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                });

                await delete_chat({chat_id: conversation.id});

                // 从列表中移除
                this.conversationList = this.conversationList.filter(item => item.id !== conversation.id);

                // 如果删除的是当前激活的会话，直接走新建会话逻辑
                if (this.activeConversation === conversation.id) {
                    await this.handleNewChat();
                }

                this.$message.success('对话已删除');
            } catch (error) {
                if (error !== 'cancel') {
                    this.$message.error('删除对话失败: ' + (error.message || error));
                }
            }
        },

        // 重命名会话
        async handleRenameConversation(conversation, newName) {
            try {
                await rename_chat({chat_id: conversation.id, title: newName});

                // 更新本地数据
                const index = this.conversationList.findIndex(item => item.id === conversation.id);
                if (index !== -1) {
                    this.conversationList[index].label = newName;
                }

                this.$message.success('重命名成功');
            } catch (error) {
                this.$message.error('重命名失败: ' + error.message);
            }
        },

        // 编辑标题
        handleEditTitle() {
            if (!this.activeConversation) return;

            this.$prompt('请输入新的对话标题', '重命名对话', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: this.currentConversationTitle,
            })
                .then(({value}) => {
                    if (value && value.trim()) {
                        const conversation = this.conversationList.find(
                            item => item.id === this.activeConversation,
                        );
                        this.handleRenameConversation(conversation, value.trim());
                    }
                })
                .catch(() => {
                });
        },

        // 侧边栏/移动端 分享菜单：分享整个会话，model_id 传 0
        handleShareConversation(item) {
            this.handleShareMessage({chatId: item.id, modelId: 0});
        },

        // 打开分享弹窗（来源：列标题分享按钮 / 侧边栏分享菜单）
        handleShareMessage({chatId, modelId} = {}) {
            this.shareChatId = chatId !== undefined ? chatId : this.chat_id;
            this.shareModelId = modelId !== undefined ? modelId : 0;
            this.shareUrl = '';
            this.shareExpireDay = 1; // 每次打开都重置为默认的 1 天
            this.shareDialogVisible = true;
        },

        // 复制/获取分享链接：点击后请求接口获取链接并复制到剪贴板，成功后关闭弹窗
        async copyShareUrl() {
            try {
                const shareUrl = this.shareUrl || await this.fetchShareUrl();
                await this.copyToClipboard(shareUrl);
                this.$message.success('分享成功，链接已复制到剪贴板，请粘贴到浏览器打开');
                this.shareDialogVisible = false;
            } catch (err) {
                this.$message.error(err.message || err || '操作失败');
            }
        },

        // 请求分享链接
        async fetchShareUrl() {
            const response = await share_chat({
                chat_id: this.shareChatId,
                model_id: this.shareModelId,
                expire_day: this.shareExpireDay,
            });
            const shareUrl = response && response.result ? response.result.share_url : null;
            if (!shareUrl) throw new Error('分享链接获取失败');
            this.shareUrl = shareUrl;
            return shareUrl;
        },

        // 复制文本到剪贴板
        async copyToClipboard(text) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                return navigator.clipboard.writeText(text);
            }
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.cssText = 'position:fixed;opacity:0;';
            document.body.appendChild(textarea);
            textarea.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(textarea);
            if (!ok) throw new Error('复制失败');
        },
    },
};
